import type { IconSvgObject } from './types';

const Flag01Icon: IconSvgObject = [
  ["path", { d: "M5 20.9971V16.0042M5 16.0042L5 3.01223C5 3.00505 5.00734 3.00021 5.01394 3.00304L18.4058 8.74076C18.6405 8.84132 18.6502 9.17046 18.4219 9.28477L5 16.0042Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }]
];

export default Flag01Icon;
